const download_app = {
  enjoy_a_better_mobile:
    'Enjoy a better mobile experience by downloading the app!',
  scan_to_upload_to: 'Scan to download on',
  available_on_playStore: 'Available on PlayStore',
  available_on_appStore: 'Available on AppStore',
}

export default download_app
